import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'article-bt-guide-2025': 'https://readdy.ai/api/search-image?query=Warm%20toned%20modern%20digital%20technology%20concept%20with%20abstract%20geometric%20shapes%20and%20soft%20gradient%20lighting%2C%20minimalist%20editorial%20style%2C%20clean%20background%20with%20subtle%20data%20flow%20patterns%2C%20cinematic%20depth%20of%20field%2C%20harmonious%20composition%2C%20no%20text%2C%20no%20human%20faces&width=800&height=500&seq=article-bt-guide-2025&orientation=landscape',
  'article-magnet-vs-torrent': 'https://readdy.ai/api/search-image?query=Modern%20digital%20data%20connection%20nodes%20with%20magnetic%20link%20visual%20metaphor%2C%20warm%20terracotta%20and%20golden%20amber%20gradient%2C%20abstract%20network%20topology%2C%20clean%20minimalist%20style%2C%20soft%20glowing%20particles%2C%20editorial%20photography%2C%20no%20text%2C%20no%20human%20faces&width=800&height=500&seq=article-magnet-vs-torrent&orientation=landscape',
  'article-summer-movies': 'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20film%20reel%20and%20projector%20light%20concept%2C%20warm%20golden%20hour%20tones%20with%20soft%20bokeh%20effects%2C%20elegant%20minimalist%20composition%2C%20artistic%20depth%20of%20field%2C%20movie%20entertainment%20vibe%2C%20no%20text%2C%20no%20human%20faces&width=800&height=500&seq=article-summer-movies&orientation=landscape',
  'article-lossless-music': 'https://readdy.ai/api/search-image?query=Abstract%20sound%20wave%20visualization%20with%20warm%20golden%20and%20amber%20gradient%20background%2C%20elegant%20audio%20frequency%20spectrum%20lines%2C%20modern%20minimalist%20design%2C%20soft%20cinematic%20lighting%2C%20harmonious%20clean%20composition%2C%20no%20text%2C%20no%20human%20faces&width=800&height=500&seq=article-lossless-music&orientation=landscape',
};

export default function ArticleSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
              热门文章
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              最新搜索技巧、资源推荐与使用指南
            </p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={articleImages[article.imageSeq] || articleImages['article-bt-guide-2025']}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-md bg-primary-500 text-white">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span>{article.readTime}阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
          >
            更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}